import { siteService } from '../services';
import { alertActions } from './alert';

const GETMYSITELIST_SUCCESS = 'mySite/GETMYSITELIST_SUCCESS';
const GETMYSITELIST_FAILURE = 'mySite/GETMYSITELIST_FAILURE';
const SETMYSITEID = 'mySite/GETMYSITEID';
const LOGOUT = 'authentication/LOGOUT';

const getMySiteList = (userID) => {
    return dispatch => {
        siteService.findSiteListbyUserID(userID)
            .then(
                siteList => {
                    if (siteList.data.length > 0) dispatch(success(siteList));
                    else dispatch(alertActions.error('담당 현장이 없습니다.', '/logout'));
                },
                error => dispatch(failure(error.toString()))
            );
    };

    function success(siteList) { return { type: GETMYSITELIST_SUCCESS, siteList } }
    function failure(error) { return { type: GETMYSITELIST_FAILURE, error } }
};

const setMySiteID = (mySiteID) => {
    return { type: SETMYSITEID, mySiteID };
};

export const mySiteActions = {
    getMySiteList,
    setMySiteID
};

const initialState = {
    mySiteID: 0,
    mySiteList: []
};

function mySite(state = initialState, action) {
    switch (action.type) {
        case GETMYSITELIST_SUCCESS:
            return {
                mySiteID: action.siteList?.data.length > 0 ? action.siteList.data[0].siteID : 0,
                mySiteList: action.siteList.data
            };
        case GETMYSITELIST_FAILURE:
            return { 
                ...initialState,
                error: action.error
            };
        case SETMYSITEID:
            return {
                ...state,
                mySiteID: action.mySiteID
            };
        case LOGOUT:
            return {
                ...initialState
            };
        default:
            return state;
    }
}

export default mySite;